module.exports = __webpack_public_path__ + "static/media/illustration.ed829877.png";